import { toast } from "sonner";

/**
 * Báo "Đã có phiên bản mới" cho tab mở lâu (30/10/2026): trình duyệt (VD Edge) giữ bản JS đã tải tới khi
 * tải lại trang, nên người dùng vẫn thấy lỗi đã sửa. index.html không cache, file JS có mã băm trong tên:
 * so tên file JS chính của index.html mới nhất với file đang chạy. Không tự tải lại để không mất dữ liệu đang nhập.
 */
const CHECK_INTERVAL_MS = 5 * 60 * 1000;
const NEW_VERSION_TOAST_ID = "app-new-version";

/** Tên file JS chính (VD /assets/index-CSWGD_n0.js) trong nội dung index.html */
export function extractEntryScript(html: string): string | null {
  const m = html.match(/<script[^>]+type="module"[^>]+src="([^"]*\/assets\/index-[^"]+\.js)"/i)
    || html.match(/src="([^"]*\/assets\/index-[^"]+\.js)"/i);
  return m ? new URL(m[1], "http://x").pathname : null;
}

function currentEntryScript(): string | null {
  const el = document.querySelector<HTMLScriptElement>('script[type="module"][src*="/assets/index-"]');
  return el?.src ? new URL(el.src).pathname : null;
}

export function startVersionCheck() {
  if (typeof window === "undefined" || !import.meta.env.PROD) return;
  const running = currentEntryScript();
  if (!running) return;
  let notified = false;
  let lastCheck = 0;

  const check = async () => {
    if (notified || Date.now() - lastCheck < 30_000) return;
    lastCheck = Date.now();
    try {
      const res = await fetch(`/index.html?v=${Date.now()}`, { cache: "no-store" });
      if (!res.ok) return;
      const latest = extractEntryScript(await res.text());
      if (latest && latest !== running) {
        notified = true;
        toast.warning("Đã có phiên bản mới của hệ thống. Lưu công việc đang làm rồi bấm Tải lại để dùng bản mới.", {
          id: NEW_VERSION_TOAST_ID,
          duration: Infinity,
          action: { label: "Tải lại", onClick: () => window.location.reload() },
        });
      }
    } catch {
      // Mất mạng / máy chủ đang cập nhật: thử lại lần sau
    }
  };

  window.setInterval(check, CHECK_INTERVAL_MS);
  window.addEventListener("focus", check);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") void check();
  });
}
